import { FormValidationUtil } from '../../../utils';

const MODAL_A = {
  reimburAmt: {
    fieldName: 'reimburAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
  dependent: {
    fieldName: 'dependent',
    label: 'Name',
    placeholder: 'Select Dependent',
    validation: {
      required: {
        value: true,
        message: 'Name is required',
      },
      test: [
        {
          testName: 'is-not-less-than-zero',
          message: 'A dependent is required',
          func: FormValidationUtil.numberNotEqualTo(-1),
        },
      ],
    },
    type: 'dependent',
    datatype: 'number',
  },
};

const MODAL_B = {
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
  expFromDate: {
    fieldName: 'expFromDate',
    label: 'From Period',
    placeholder: 'Select From Period',
    validation: {
      required: {
        value: true,
        message: 'From period is required',
      },
    },
    type: 'date',
    datatype: 'string',
  },
  expToDate: {
    fieldName: 'expToDate',
    label: 'To Period',
    placeholder: 'Select To Period',
    validation: {
      required: {
        value: true,
        message: 'To period is required',
      },
      test: [
        {
          testName: 'is-after-from-period',
          message: 'To Period cannot be earlier than From Period',
          func: FormValidationUtil.endDateAfterStartDate('expFromDate'),
        },
      ],
    },
    type: 'date',
    datatype: 'string',
  },
  dependent: {
    fieldName: 'dependent',
    label: 'Child Name',
    placeholder: 'Select Dependent',
    validation: {
      required: {
        value: true,
        message: 'Child name is required',
      },
      test: [
        {
          testName: 'is-not-less-than-zero',
          message: 'Child name is required',
          func: FormValidationUtil.numberNotEqualTo(-1),
        },
      ],
    },
    type: 'dependentChild',
    datatype: 'number',
  },
};

const MODAL_C = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_D = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  expCostAlloc: {
    fieldName: 'expCostAlloc',
    label: 'Cost Allocation',
    placeholder: 'Select One',
    type: 'costAllocation',
    datatype: 'string',
  },
  countryCode: {
    fieldName: 'countryCode',
    label: 'Country',
    placeholder: 'Select a country',
    type: 'country',
    datatype: 'string',
    title: 'Select country for the claim',
  },
  product: {
    fieldName: 'product',
    label: 'Product',
    placeholder: 'Select One',
    type: 'product',
    datatype: 'string',
    title: 'Select product for the claim',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_E = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  expCostAlloc: {
    fieldName: 'expCostAlloc',
    label: 'Cost Allocation',
    placeholder: 'Select One',
    type: 'costAllocation',
    datatype: 'string',
  },
  countryCode: {
    fieldName: 'countryCode',
    label: 'Country',
    placeholder: 'Select a Country',
    type: 'country',
    datatype: 'string',
    title: 'Select country for the claim',
  },
  product: {
    fieldName: 'product',
    label: 'Product',
    placeholder: 'Select One',
    type: 'product',
    datatype: 'string',
    title: 'Select product for the claim',
  },
  expCustomer: {
    fieldName: 'expCustomer',
    label: 'Customer Name',
    placeholder: 'Select One',
    type: 'text',
    validation: {
      required: {
        value: true,
        message: 'Customer Name is required',
      },
    },
    datatype: 'string',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_F = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  sorNo: {
    fieldName: 'sorNo',
    label: 'SOR No',
    placeholder: 'Enter SOR No',
    type: 'sorNo',
    validation: {
      required: {
        value: true,
        message: 'SOR No is required',
      },
    },
    datatype: 'string',
    showBackendValidation: {
      message: 'Please enter a valid SOR No',
    },
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_G = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  expCostAlloc: {
    fieldName: 'expCostAlloc',
    label: 'Cost Allocation',
    placeholder: 'Select One',
    type: 'costAllocation',
    datatype: 'string',
  },
  sorNo: {
    fieldName: 'sorNo',
    label: 'SOR No',
    placeholder: 'Enter SOR No',
    type: 'sorNo',
    datatype: 'string',
  },
  countryCode: {
    fieldName: 'countryCode',
    label: 'Country',
    placeholder: 'Select a Country',
    type: 'country',
    datatype: 'string',
    title: 'Select country for the claim',
  },
  expCustomer: {
    fieldName: 'expCustomer',
    label: 'Customer Name',
    placeholder: 'Select One',
    type: 'text',
    validation: {
      required: {
        value: true,
        message: 'Customer Name is required',
      },
    },
    datatype: 'string',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_H = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  expCostAlloc: {
    fieldName: 'expCostAlloc',
    label: 'Cost Allocation',
    placeholder: 'Select One',
    type: 'costAllocation',
    datatype: 'string',
  },
  sorNo: {
    fieldName: 'sorNo',
    label: 'SOR No',
    placeholder: 'Enter SOR No',
    type: 'sorNo',
    datatype: 'string',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_I = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  noOfIndividuals: {
    fieldName: 'noOfIndividuals',
    label: 'No. Of Individuals',
    placeholder: 'Enter No. Of Individuals',
    validation: {
      required: {
        value: true,
        message: 'No. Of Individuals are required',
      },
    },
    type: 'noOfIndividuals',
    datatype: 'number',
  },
  expCostAlloc: {
    fieldName: 'expCostAlloc',
    label: 'Cost Allocation',
    placeholder: 'Select One',
    type: 'costAllocation',
    datatype: 'string',
  },
  countryCode: {
    fieldName: 'countryCode',
    label: 'Country',
    placeholder: 'Select a country',
    type: 'country',
    datatype: 'string',
    title: 'Select country for the claim',
  },
  product: {
    fieldName: 'product',
    label: 'Product',
    placeholder: 'Select One',
    type: 'product',
    datatype: 'string',
    title: 'Select product for the claim',
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

const MODAL_J = {
  entity: {
    fieldName: 'entity',
    label: 'Entity',
    placeholder: 'Select One',
    validation: {
      required: {
        value: true,
        message: 'Entity is required',
      },
    },
    type: 'entity',
    datatype: 'string',
  },
  noOfIndividuals: {
    fieldName: 'noOfIndividuals',
    label: 'No. Of Individuals',
    placeholder: 'Enter No. Of Individuals',
    validation: {
      required: {
        value: true,
        message: 'No. Of Individuals are required',
      },
    },
    type: 'noOfIndividuals',
    datatype: 'number',
  },
  sorNo: {
    fieldName: 'sorNo',
    label: 'SOR No',
    placeholder: 'Enter SOR No',
    type: 'sorNo',
    validation: {
      required: {
        value: true,
        message: 'SOR No is required',
      },
    },
    datatype: 'string',
    showBackendValidation: {
      message: 'Please enter a valid SOR No',
    },
  },
  reimBursement: {
    fieldName: 'reimbursementAmt',
    label: 'ReimburseAmt (AED)',
    placeholder: 'Reimbursement Amount',
    type: 'reimbursementAmt',
    datatype: 'number',
    title: 'Reimbursement amount - auto filled',
  },
};

export const typeModalMapping = {
  // HR Costs
  E101: MODAL_A,
  E102: MODAL_A,
  E116: MODAL_A,
  E103: MODAL_B,
  E104: MODAL_C,
  E105: MODAL_A,
  E106: MODAL_C,
  E117: MODAL_C,
  E107: MODAL_C,
  E108: MODAL_C,
  E109: MODAL_C,
  E110: MODAL_C,
  E111: MODAL_C,
  E112: MODAL_C,
  E113: MODAL_C,
  E114: MODAL_C,
  E126: MODAL_C,
  E127: MODAL_C,
  E129: MODAL_C,
  E130: MODAL_C,
  E128: MODAL_C,
  E115: MODAL_C,

  // Marketing
  E201: MODAL_G,
  E202: MODAL_H,
  E203: MODAL_H,

  // Business
  E301: MODAL_D,
  E323: MODAL_D,
  E302: MODAL_D,
  E303: MODAL_D,
  E304: MODAL_D,
  E322: MODAL_D,
  E305: MODAL_D,
  E306: MODAL_E,
  E307: MODAL_I,
  E308: MODAL_D,
  E309: MODAL_D,
  E310: MODAL_D,
  E311: MODAL_D,
  E312: MODAL_D,
  E313: MODAL_D,
  E314: MODAL_D,
  E315: MODAL_D,
  E316: MODAL_D,
  E317: MODAL_D,
  E318: MODAL_D,
  E319: MODAL_D,
  E320: MODAL_D,
  E321: MODAL_D,
  E333: MODAL_D,
  E334: MODAL_D,
  E335: MODAL_D,
  E336: MODAL_D,
  E337: MODAL_D,
  E338: MODAL_D,
  E399: MODAL_D,

  // Project SOR
  E401: MODAL_F,
  E402: MODAL_F,
  E403: MODAL_F,
  E404: MODAL_F,
  E405: MODAL_F,
  E406: MODAL_F,
  E407: MODAL_J,
  E481: MODAL_F,
  E495: MODAL_F,
};
